'use client'
import { Menu } from "./menu/menu";
import { MobileMenu } from "./menu/mobile-menu";
import Image from "next/image";
import logo from "@/assets/oem_transparent.png"
import { LogOut } from "./user/logout";
import { LogIn } from "./user/login";

import { getCurrentUser, userAdmin, userClient, userSeller, userAccountant } from "@/app/api";
import { AdminMenu, SellerMenu, ClientMenu, AccountantMenu, } from "@/components/auth";
import { SmartLink } from "@/components/ui";
import { useEffect, useState } from "react";

export function Header() {
    const [user, setUser] = useState<{ name: string }>({ name: '' })
    const [client, setClient] = useState<{ name: string }>({ name: '' })
    const [seller, setSeller] = useState<{ name: string }>({ name: '' })
    const [accountant, setAccountant] = useState<{ name: string }>({ name: '' })
    const [admin, setAdmin] = useState<{ name: string }>({ name: '' })

    useEffect(() => {
        const fetchUser = async () => {
            const user = await getCurrentUser();
            const client = await userClient();
            const seller = await userSeller();
            const accountant = await userAccountant();
            const admin = await userAdmin();
            setUser(user)
            setClient(client)
            setSeller(seller)
            setAccountant(accountant)
            setAdmin(admin)
        };
        fetchUser();
    }, [])





    return (
        <div className="h-20 w-full px-10 top-0 flex items-center justify-between fixed z-999 bg-light_secondary dark:bg-dark_secondary shadow-lg">

            <div className="flex gap-6 items-center justify-center ">
                <MobileMenu user={user} />
                <Menu user={user} />
            </div>

            <div className="flex sm:hidden absolute left-1/2 transform -translate-x-1/2">
                <SmartLink type="external" route="home" className="z-20">
                    <Image priority src={logo} alt="Logo O&M" width={640} height={429} className="h-10 w-auto" unoptimized={true} />
                </SmartLink>
            </div>

            <div className="flex items-center gap-2">
                {user ? <LogOut user={user} /> : <LogIn />}

                {admin && <AdminMenu />}
                {client && <ClientMenu />}
                {seller && <SellerMenu />}
                {accountant && <AccountantMenu />}
            </div>
        </div>
    )
}